import React, { useState } from "react";
import { Container } from "react-bootstrap";
import img1 from "../../assets/Images/Blogs/sitting-room-with-old-furniture.jpg";
import { useIsMobile } from "../../utils/responsive";
export default function Section4() {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <h3 className="heading-sm m-0">
              DIFFERENCE BETWEEN HUE, TINT & SHADE
            </h3>
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      {!isMobile && (
        <div className="d-flex justify-content-center">
          {!isMobile && (
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
          )}
          <div
            style={{
              width: isMobile ? "50%" : "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <h3 className="heading-sm m-0">HUE</h3>
            </div>
          </div>
          <div
            style={{
              width: isMobile ? "50%" : "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <h3 className="heading-sm m-0">TINT & SHADEs</h3>
            </div>
          </div>

          {!isMobile && (
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          )}
        </div>
      )}
      {!isMobile && (
        <div className="d-flex justify-content-center">
          {!isMobile && (
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
          )}
          <div
            style={{
              width: isMobile ? "50%" : "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <p className="body-lg m-0">
                A hue is the purest form of any color, whether it's primary,
                secondary, tertiary or somewhere in between on the spectrum of
                colors on the wheel. Hues are very intense and are very
                dramatic, so they are usually lightened or darkened for the
                majority of decorating schemes to create a tint or a shade.
              </p>
            </div>
          </div>
          <div
            style={{
              width: isMobile ? "50%" : "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <p className="body-lg m-0">
                The addition of white or black to a color will create a tint or
                a shade. If you add some black to a hue, you create a shade and
                go darker. If you add white, you create a tint and go lighter.
              </p>
            </div>
          </div>

          {!isMobile && (
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          )}
        </div>
      )}
      {isMobile && (
        <div className="d-flex justify-content-center">
          <div className="w-100">
            <h3
              className="heading-sm m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              HUE
            </h3>
            <p
              className="body-lg m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              A hue is the purest form of any color, whether it's primary,
              secondary, tertiary or somewhere in between on the spectrum of
              colors on the wheel. Hues are very intense and are very dramatic,
              so they are usually lightened or darkened for the majority of
              decorating schemes to create a tint or a shade.
            </p>

            <h3
              className="heading-sm m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              TINT & SHADEs
            </h3>
            <p
              className="body-lg m-0"
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              The addition of white or black to a color will create a tint or a
              shade. If you add some black to a hue, you create a shade and go
              darker. If you add white, you create a tint and go lighter.
            </p>
          </div>
        </div>
      )}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <h3 className="heading-sm m-0">WHAT COLORS GO TOGETHER?</h3>
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                padding: "20px 40px",
              }}
            >
              <p className="body-lg m-0">
                If you follow the rules of the color wheel, you will discover a
                wide selection of palettes to choose from. Some of these
                combinations you will already be familiar with, while others you
                may not have come across before.
              </p>
              <p className="body-lg m-0">
                'Deciphering what colours go well together depends on where on
                the colour wheel they sit', continues Shaw. 'Consider creating a
                monochromatic scheme which uses varying levels of saturation of
                one colour. We would recommend using a paler shade of one and a
                darker hue of another.'
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            borderBottom: "1px solid black",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <div
            style={{
              height: "100%",
              overflow: "hidden",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img
              src={img1}
              alt="Profile 1"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                maxHeight: "500px",
                transition: "all 0.5s ease",
                transform: isHovered ? "scale(1.05)" : "scale(1)",
                filter: isHovered ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
